// Jump links for sections/faq.liquid.
//
// WHY THIS FILE EXISTS AT ALL — a plain href="#id" does not work here.
// Horizon's layout puts `overflow: hidden` on both <html> and <body> and scrolls
// inside `div.page-wrapper`. Fragment navigation therefore updates the URL and
// moves nothing: verified on Staging 2026-08-26 by loading the anchor URL
// directly — wrapper scrollTop stayed 0 with the target 2858px down.
//
// WHY A SEPARATE ASSET AND NOT {% javascript %} — this was first written as a
// {% javascript %} block and it did not work, but the cause turned out to be
// the 'smooth' bug below, NOT the tag. Whether Horizon bundles {% javascript %}
// from a section is therefore UNPROVEN — do not repeat it here as fact. The
// asset + explicit <script src> route is used because it is already proven in
// this theme (see assets/variant-reactive.js), not because the other is broken.
//
// WHY ALWAYS 'instant', NEVER 'smooth' OR 'auto' — this is the part that cost
// the most time. The module loads and the listener registers (proved with
// window.__faqJumpReady), but a scrollTo with 'smooth' moves the container
// ZERO pixels. 'auto' inherits the container's own CSS `scroll-behavior:
// smooth` and fails the same way. Only 'instant' actually scrolls it.
// Measured on Staging 2026-08-26: 'smooth' left scrollTop at 0 with the target
// 2858px down; 'instant' landed it at 2739 with the heading at 120px.
// So the jump is a jump. Do not "improve" this to smooth without re-measuring.

// Fallback only, for a jump bar that is not sticky. When it IS sticky the
// clearance is measured, not guessed: a fixed 120 was right for the header
// alone and left the topic heading UNDER the sticky bar once that shipped.
const HEADER_OFFSET = 120;
const BREATHING_ROOM = 16;

function scrollerFor(element) {
  return element.closest('.page-wrapper') || document.scrollingElement;
}

// How far down the viewport content has to land to clear everything pinned
// above it. The bar's own sticky `top` already accounts for the site header,
// so top + height is the bottom edge of the pinned stack.
function clearance(bar) {
  if (!bar || !bar.classList.contains('faq__jump-bar--sticky')) return HEADER_OFFSET;
  const top = parseFloat(getComputedStyle(bar).top);
  if (Number.isNaN(top)) return HEADER_OFFSET;
  return top + bar.offsetHeight + BREATHING_ROOM;
}

function barFor(element) {
  const section = element.closest('.faq') || document;
  return section.querySelector('.faq__jump-bar');
}

function jumpTo(target) {
  const scroller = scrollerFor(target);
  const delta = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;

  scroller.scrollTo({
    top: scroller.scrollTop + delta - clearance(barFor(target)),
    behavior: 'instant',
  });
}

// Which topic you are reading, marked on its chip. The mockup draws the current
// chip filled; without this the bar is three identical outlines and says nothing
// about where you are.
function markCurrentChip(bar) {
  const chips = Array.from(bar.querySelectorAll('.faq__chip'));
  if (chips.length === 0) return;

  const targets = chips.map((chip) => {
    try {
      return document.getElementById(decodeURIComponent(chip.hash.slice(1)));
    } catch (error) {
      return null;
    }
  });

  const scroller = scrollerFor(bar);
  let pending = 0;

  const update = () => {
    pending = 0;
    const line = clearance(bar);
    let current = 0;
    targets.forEach((target, index) => {
      if (target && target.getBoundingClientRect().top <= line) current = index;
    });
    chips.forEach((chip, index) => {
      chip.classList.toggle('faq__chip--current', index === current);
    });
  };

  const schedule = () => {
    if (!pending) pending = requestAnimationFrame(update);
  };

  scroller.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
}

document.querySelectorAll('.faq__jump-bar').forEach(markCurrentChip);

document.addEventListener('click', (event) => {
  const chip = event.target.closest('.faq__chip');
  if (!chip || !chip.hash) return;

  let target;
  try {
    target = document.getElementById(decodeURIComponent(chip.hash.slice(1)));
  } catch (error) {
    // A malformed hash is not worth breaking the click over — fall through to
    // the browser's own (no-op) handling rather than throwing.
    return;
  }
  if (!target) return;

  event.preventDefault();
  jumpTo(target);
  history.replaceState(null, '', chip.hash);
});

// Load marker. The <script> tag rendered and the asset returned 200, yet no
// handler was active on Staging 2026-08-26 — this is how that gets told apart
// next time without guessing.
window.__faqJumpReady = true;
